/* Selvaggio Edilpref — Dynamic Professional interactions */
(function(){
  'use strict';
  if(window.__SE_DYNAMIC_PRO__) return;
  window.__SE_DYNAMIC_PRO__ = true;

  /* Homepage hero premium: Verona Beige ambientato */
  var premiumHeroUrl = 'https://cdn.shopify.com/s/files/1/0261/3637/9476/files/e96caa94ef91b96bda3bdb6e3101f3bf.webp?v=1712250693';
  var premiumHeroAlt = 'Ambiente contemporaneo con pavimento in gres Verona Beige di Selvaggio Edilpref';

  function applyPremiumHomepageHero(){
    /* Current editorial homepage hero */
    var heroImg = document.querySelector('body.template-index .se-hero-media img');
    if(heroImg){
      heroImg.removeAttribute('srcset');
      heroImg.removeAttribute('sizes');
      heroImg.src = premiumHeroUrl + '&width=1800';
      heroImg.srcset = premiumHeroUrl + '&width=600 600w, ' + premiumHeroUrl + '&width=900 900w, ' + premiumHeroUrl + '&width=1200 1200w, ' + premiumHeroUrl + '&width=1500 1500w, ' + premiumHeroUrl + '&width=1800 1800w, ' + premiumHeroUrl + '&width=2000 2000w';
      heroImg.sizes = '(min-width: 1000px) 55vw, 100vw';
      heroImg.alt = premiumHeroAlt;
      heroImg.width = 2000;
      heroImg.height = 750;
      heroImg.style.objectPosition = 'center center';
      heroImg.setAttribute('data-se-premium-hero', 'verona-beige');
    }

    /* Legacy hero fallback if an older homepage template is restored. */
    var legacyHero = document.querySelector('body.template-index [data-section-type="hero-section"] .hero');
    if(legacyHero){
      legacyHero.removeAttribute('data-bgset');
      legacyHero.style.setProperty('background-image', 'url("' + premiumHeroUrl + '")', 'important');
      legacyHero.style.setProperty('background-position', 'center center', 'important');
      legacyHero.style.setProperty('background-size', 'cover', 'important');
      legacyHero.setAttribute('data-se-premium-hero', 'verona-beige');
    }
  }

  /* Deferred scripts execute after parsing, so the actual hero is available here. */
  applyPremiumHomepageHero();

  function ready(fn){
    if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn, {once:true});
    else fn();
  }

  ready(function(){
    var body = document.body;
    if(!body) return;

    applyPremiumHomepageHero();

    body.classList.add('se-dyn-enhanced');
    requestAnimationFrame(function(){ body.classList.add('se-dyn-ready'); });

    var ticking = false;
    function applyScrollState(){
      body.classList.toggle('se-dyn-scrolled', window.pageYOffset > 24);
      ticking = false;
    }
    function onScroll(){
      if(!ticking){
        requestAnimationFrame(applyScrollState);
        ticking = true;
      }
    }
    applyScrollState();
    window.addEventListener('scroll', onScroll, {passive:true});

    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var targets = Array.prototype.slice.call(document.querySelectorAll(
      '.index-section, .section-header, .grid-view-item, .collection-grid-item, .feature-row, .product-single, .site-footer__item'
    ));

    if(!targets.length) return;

    targets.forEach(function(el, i){
      if(el.closest('.hero')) return;
      el.classList.add('se-dyn-reveal');
      el.style.setProperty('--se-delay', Math.min((i % 4) * 55, 165) + 'ms');
    });

    var revealTargets = targets.filter(function(el){ return el.classList.contains('se-dyn-reveal'); });

    if(reduceMotion || !('IntersectionObserver' in window)){
      revealTargets.forEach(function(el){ el.classList.add('se-dyn-visible'); });
      return;
    }

    var observer = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if(entry.isIntersecting){
          entry.target.classList.add('se-dyn-visible');
          observer.unobserve(entry.target);
        }
      });
    }, {threshold:0.08, rootMargin:'0px 0px -36px 0px'});

    revealTargets.forEach(function(el){
      var rect = el.getBoundingClientRect();
      if(rect.top < window.innerHeight * 0.92){
        el.classList.add('se-dyn-visible');
      } else {
        observer.observe(el);
      }
    });
  });
})();
